// 2_components/search_raventic_results_setup.js
// Vendor Raventic search-RESULTS integration (v4 SDK): defines
// window.RaventicSearchResultsConfig and runs Raventic's loader snippet (vendor code,
// left untouched); transforms Raventic's product list into Shoptet-style product cards
// (rating, stock, price, add-to-cart) with re-transform via MutationObserver, go-to-top
// button, filter heading, promo-content classes; plus the misc search listeners
// (empty query, mobile search button, click-outside close, filter toggle button).

export function init() {
	if (!window.NAT?.raventic || !window.NAT?.utils?.goTopBtn) {
		console.warn(
			"[NAT] search_raventic_results_setup.js: window.NAT.raventic or window.NAT.utils.goTopBtn missing — check load order",
		);
		return;
	}

	raventicSetupResults();
	searchRaventicResults();

	// Empty search
	document.addEventListener("RAVENTIC SEARCH RESULTS LOADED", function () {
		emptySearchQuery();
	});

	document.addEventListener("DOMContentLoaded", function () {
		addSearchButtonForMobile();
		clickOutsideSearchDropdown();
	});

	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", function (event) {
		addFilterButtonToggleRaventic();
		function addFilterButtonToggleRaventic() {
			const alreadyExistsRaventicFilterButton = document.querySelector(".custom-open-filter-button");
			if (alreadyExistsRaventicFilterButton) return;

			const customOpenFilterButtonRaventic = document.createElement("a");
			customOpenFilterButtonRaventic.className = "custom-open-filter-button";
			customOpenFilterButtonRaventic.innerHTML = window.NAT.translations("customFilterButton");

			try {
				const raventicResultsTop = document.querySelector(".raventic-search-results-container");
				raventicResultsTop.appendChild(customOpenFilterButtonRaventic);

				customOpenFilterButtonRaventic.addEventListener("click", function () {
					const raventicFilters = document.querySelector(".raventic-search-results-filters");
					if (raventicFilters) {
						raventicFilters.classList.toggle("active");
					}
					customOpenFilterButtonRaventic.classList.toggle("active");
				});
			} catch (error) {
				console.error("Error in customOpenFilterButtonListener:", error);
			}
		}
	});
}

function raventicSetupResults() {
	if (!location.href.includes(window.NAT.raventic[window.NAT.lang].resultsUrlMatch)) return;

	window.RaventicSearchResultsConfig = {
		elementSelector: "#content",
		config: {
			locale: window.NAT.raventic[window.NAT.lang].locale,
			apiKey: window.NAT.raventic[window.NAT.lang].apiKey,

			currency: window.NAT.raventic[window.NAT.lang].currency,
			priceDecimals: window.NAT.raventic[window.NAT.lang].priceDecimals,

			noResultsFoundMessage: window.NAT.translations("raventicNoResults"),

			queryParameterName: "string",

			pageSize: 20,

			title: window.NAT.translations("raventicResultsTitle"),
			noQueryTitle: window.NAT.translations("raventicNoQueryTitle"),

			categoriesTitle: window.NAT.translations("raventicCategoriesTitle"),
			manufacturersTitle: window.NAT.translations("raventicManufacturersTitle"),
			showManufacturers: false,
			analyticsEventsTarget: "dataLayer",

			priceTitle: window.NAT.translations("raventicPriceTitle"),

			disableDefaultStyles: true,
			doNotCropImages: true,

			filtersTitle: window.NAT.translations("raventicFiltersTitle"),
			filterButtonTitle: window.NAT.translations("raventicFilterButton"),
			clearAllFiltersTitle: window.NAT.translations("raventicClearAllFilters"),
			buttonTypeParameterName: "button-type",
			buttonLabelParameterName: "button-text",
			buttonStyleParameterName: "button-style",

			priceParameterName: "_price",
			salePriceParameterName: "_sale-price",

			individualParameters: [
				{
					parameterName: "SHORT_DESCRIPTION",
					title: window.NAT.translations("raventicParamDescription"),
				},
				{
					parameterName: "RATING_AVG",
					title: window.NAT.translations("raventicParamRating"),
				},
				{
					parameterName: "RATING_TOTAL",
					title: window.NAT.translations("raventicParamReviewCount"),
				},
				{
					parameterName: "IMGURL_ALTERNATIVE",
					title: window.NAT.translations("raventicParamAltImage"),
				},
				{
					parameterName: "STOCK_AMOUNT",
					title: window.NAT.translations("raventicParamStock"),
				},
			],

			promoContent: [
				{
					title: window.NAT.translations("raventicCategoriesTitle"), // block title
					identifier: "categories_feed",
					maxCount: 8,
				},
				{
					title: window.NAT.translations("raventicArticlesTitle"), // tab title for article results
					identifier: "articles",
					maxCount: 3, // maximum number of results per page
				},
			],

			customStyles: ``,
			customPageStyles: ``,

			desktopMode: "left",

			defaultButtonLabel: window.NAT.translations("raventicAddToCart"),
			cartConfig: {
				type: "NoActionCart",
			},
		},
		onProductClick: handleProductClick,
		resultHandler: handleResult,
		runABTest: false,
	};

	// Vendor Raventic v4 loader — reads window.RaventicSearchResultsConfig and injects
	// .../semsearch/v4/results.min.js. Left exactly as provided by Raventic.
	// NOTE: the loader assigns an undeclared "variant" global inside its runABTest
	// branch; under ESM strict mode that would throw, but runABTest is false above,
	// so the branch never executes.
	!(function () {
		const e = window.RaventicSearchResultsConfig;
		if (!e)
			return void console.error(
				"RaventicSearchResultsConfig is not defined. Please set window.RaventicSearchResultsConfig before loading this script.",
			);
		const {
			elementSelector: t,
			config: n,
			onOpen: a,
			onProductClick: i,
			errorHandler: r,
			resultHandler: o,
			eventPusher: c,
			runABTest: s,
		} = e;
		if (s) {
			const e = "search_dropdown",
				t = "RaventicSearchIntegrationTest";
			void 0 === window.dataLayer && (window.dataLayer = []);
			const n = "_rvn_ab",
				a = "0",
				i = "1";
			let r = null;
			try {
				r = window.localStorage.getItem(n);
			} catch {
				r = document.cookie
					.split("; ")
					.find((e) => e.startsWith(n + "="))
					?.split("=")[1];
			}
			variant = r === a || r === i ? r : Math.random() < 0.5 ? a : i;
			try {
				window.localStorage.setItem(n, variant);
			} catch {}
			if (
				((document.cookie = `${n}=${variant}; domain=${location.hostname}; path=/; max-age=${365 * 86400}; sameSite=Lax`),
				t &&
					window.dataLayer.push({ event: t, raventic: { search: {}, raventic_variant: variant, raventic_widget: e } }),
				variant === a)
			)
				return;
		}
		let d = !1;
		window.raventicResultsReady = function (e) {
			d || ((d = !0), e(t, n, a, i, r, o, c));
		};
		const l = document.createElement("script");
		((l.src = "https://sdk.rvndn.com/semsearch/v4/results.min.js"), document.head.appendChild(l));
	})();
}

function handleProductClick(product, instanceId, action) {
	if (action === "add-to-cart") {
		shoptet.cartShared.addToCart({ productCode: product.id });
	}
}

function handleResult(result, error, reference, instanceId) {
	if (error) {
		console.error("Raventic API error:", error);
		return;
	}
	window.raventicResult = result;
	document.dispatchEvent(new CustomEvent("RAVENTIC SEARCH RESULTS LOADED"));
	console.log(
		"%c CUSTOM EVENT DISPATCHED: RAVENTIC SEARCH RESULTS LOADED",
		"background: lime; color: black; padding: 5px 10px; font-weight: bold;",
	);
}

// Raventic search results page: transforms Raventic's product list into Shoptet-style
// product cards (rating, stock, price, add-to-cart), re-transforming via a
// MutationObserver, and adds a go-to-top button, filter heading, per-identifier classes
// on the promo-content blocks.
function searchRaventicResults() {
	document.addEventListener(
		"RAVENTIC SEARCH RESULTS LOADED",
		() => {
			editRaventicSearchResults();
		},
		{ once: true },
	);

	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", () => {
		document.body.classList.add("raventic-search-results-transformed");
		addGoToTopButton();
		addFilterHeading();
		addPromoContentClasses();
		removeUnwantedFilters();
		scheduleRaventicPriceSlider();
	});

	function editRaventicSearchResults() {
		const RV_LIST_SELECTOR = ".raventic-search-results-products-list";
		const TRANSFORMED_FLAG = "shoptetTransformed";

		function escapeHtml(s) {
			return String(s).replace(
				/[&<>"']/g,
				(c) =>
					({
						"&": "&amp;",
						"<": "&lt;",
						">": "&gt;",
						'"': "&quot;",
						"'": "&#39;",
					})[c],
			);
		}

		function getParamValue(product, name) {
			const el = product.querySelector(`[data-raventic-parameter="${name}"] [data-raventic-parameter-value]`);
			return el ? el.getAttribute("data-raventic-parameter-value") : null;
		}

		function getParamText(product, name) {
			const wrap = product.querySelector(`[data-raventic-parameter="${name}"]`);
			if (!wrap) return null;
			const inner = wrap.querySelector("span[title] span[title]") || wrap.querySelector("span[title]");
			return inner ? inner.textContent.trim() : null;
		}

		function buildStars(avg) {
			const v = parseFloat(avg);
			if (isNaN(v)) return "";
			const rounded = Math.round(v * 2) / 2;
			let html = '<span class="stars star-list">';
			for (let i = 1; i <= 5; i++) {
				if (rounded >= i) html += '<span class="star star-on"></span>';
				else if (rounded >= i - 0.5) html += '<span class="star star-half"></span>';
				else html += '<span class="star"></span>';
			}
			return html + "</span>";
		}

		function relativizeHref(href) {
			if (!href) return "#";
			return href.replace(/^https?:\/\/[^/]+/, "") || "#";
		}

		function findProductByHref(href) {
			const products = window.raventicResult?.products;
			if (!Array.isArray(products)) return null;
			const target = relativizeHref(href).replace(/\/$/, "");
			return (
				products.find((p) => {
					if (!p?.url) return false;
					const candidate = relativizeHref(p.url).replace(/\/$/, "");
					return candidate === target;
				}) || null
			);
		}

		function buildProductCard(rvProduct) {
			const href = relativizeHref(rvProduct.getAttribute("href"));
			const apiProduct = findProductByHref(href);
			const productId = apiProduct?.id || "";
			const name = (rvProduct.querySelector(".raventic-product-name")?.textContent || "").trim();
			const imgEl = rvProduct.querySelector(".raventic-product-image img");
			const imgSrc = imgEl?.getAttribute("src") || "";
			const imgAlt = imgEl?.getAttribute("alt") || name;
			const altImg = (getParamValue(rvProduct, "imgurl_alternative") || "").replace("/orig/", "/detail/");
			const ratingAvg = getParamValue(rvProduct, "rating_avg");
			const ratingTotal = getParamValue(rvProduct, "rating_total");
			const stockAmount = getParamValue(rvProduct, "stock_amount");
			const description = getParamText(rvProduct, "short_description");
			const price = (rvProduct.querySelector(".raventic-product-price-value")?.textContent || "").trim();
			const priceBefore = (rvProduct.querySelector(".raventic-product-price-before")?.textContent || "").trim();
			const cartBtn = rvProduct.querySelector(".raventic-product-button-cart");

			const priceNum = parseFloat(price.replace(/[^\d.,]/g, "").replace(",", "."));
			const priceBeforeNum = parseFloat(priceBefore.replace(/[^\d.,]/g, "").replace(",", "."));
			const hasDiscount = priceBefore && !isNaN(priceNum) && !isNaN(priceBeforeNum) && priceBeforeNum > priceNum;
			const discountPercent = hasDiscount ? Math.floor((1 - priceNum / priceBeforeNum) * 100) : 0;

			const parts = [];
			parts.push('<div class="p" data-testid="productItem">');

			parts.push(`<a href="${escapeHtml(href)}" class="image">`);
			if (hasDiscount) {
				parts.push(
					`<div class="flags flags-extra"><span class="flag flag-discount"><span class="price-save">–${discountPercent}&nbsp;%</span></span></div>`,
				);
			}
			if (imgSrc) {
				parts.push(
					`<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(imgAlt)}" width="423" height="318" loading="lazy">`,
				);
			}
			parts.push("</a>");

			parts.push('<div class="p-in"><div class="p-in-in">');

			if (name) {
				parts.push(
					`<a href="${escapeHtml(href)}" class="name"><span data-testid="productCardName">${escapeHtml(name)}</span></a>`,
				);
			}

			const hasRating = ratingAvg != null;
			const hasStock = stockAmount != null;
			const stockNum = hasStock ? parseInt(stockAmount, 10) : NaN;
			const isUnavailable = hasStock && (isNaN(stockNum) || stockNum <= 0);
			if (hasRating || hasStock) {
				parts.push('<div class="ratings-wrapper">');
				if (hasRating) {
					const cnt = ratingTotal != null ? ` data-micro-rating-count="${escapeHtml(ratingTotal)}"` : "";
					parts.push(
						`<div class="stars-wrapper" data-micro-rating-value="${escapeHtml(ratingAvg)}"${cnt}>${buildStars(ratingAvg)}</div>`,
					);
				}
				if (hasStock) {
					if (isUnavailable) {
						parts.push(
							`<div class="availability"><span style="color:#cb0000">${window.NAT.translations("nedostupne")}</span></div>`,
						);
					} else {
						const stockText = stockNum >= 10 ? "(&gt;10&nbsp;ks)" : `(${stockNum}&nbsp;ks)`;
						parts.push(
							`<div class="availability"><span style="color:#009901">${window.NAT.translations("skladem")}</span> <span class="availability-amount" data-testid="numberAvailabilityAmount">${stockText}</span></div>`,
						);
					}
				}
				parts.push("</div>");
			}

			parts.push("</div>");

			parts.push('<div class="p-bottom single-button"><div>');

			if (price) {
				const standard = hasDiscount
					? `<span class="price-standard"><span>${escapeHtml(priceBefore)}</span></span>`
					: "";
				parts.push(
					`<div class="prices"><div class="price price-final" data-testid="productCardPrice"><strong>${escapeHtml(price)}</strong>${standard}</div></div>`,
				);
			}

			if (cartBtn) {
				parts.push(
					`<div class="p-tools"><button type="button" class="btn btn-cart add-to-cart-button raventic-add-to-cart-button" data-testid="buttonAddToCart" aria-label="${window.NAT.translations("doKosiku")} ${escapeHtml(name)}"><span>${window.NAT.translations("doKosiku")}</span></button></div>`,
				);
			}

			if (description) {
				parts.push(`<p class="p-desc" data-testid="productCardShortDescr">${escapeHtml(description)}</p>`);
			}

			parts.push("</div></div>");
			parts.push("</div>");

			if (productId) {
				parts.push(`<span class="p-code">Kód: <span data-micro="sku">${escapeHtml(productId)}</span></span>`);
			}

			parts.push("</div>");

			const wrapper = document.createElement("div");
			wrapper.className = isUnavailable ? "product unavailable" : "product";
			wrapper.innerHTML = parts.join("");

			if (cartBtn) {
				const newBtn = wrapper.querySelector(".add-to-cart-button");
				newBtn?.addEventListener("click", (e) => {
					e.preventDefault();
					cartBtn.click();
				});
			}

			return wrapper;
		}

		function findExistingTransformed(list) {
			const sibling = list.nextElementSibling;
			if (sibling?.id === "products" && sibling.classList.contains("products-block")) return sibling;
			return null;
		}

		function transformResults() {
			const list = document.querySelector(RV_LIST_SELECTOR);
			if (!list) return;
			const items = list.querySelectorAll(".raventic-product");
			if (!items.length) return;
			if (list.dataset[TRANSFORMED_FLAG] === "true" && findExistingTransformed(list)) return;

			findExistingTransformed(list)?.remove();

			const container = document.createElement("div");
			container.id = "products";
			container.className = "products products-page products-block";
			container.setAttribute("data-testid", "productCards");

			items.forEach((rv) => container.appendChild(buildProductCard(rv)));

			list.style.display = "none";
			list.dataset[TRANSFORMED_FLAG] = "true";
			list.parentNode.insertBefore(container, list.nextSibling);

			console.log(
				"%c CUSTOM EVENT DISPATCHED: RAVENTIC SEARCH RESULTS TRANSFORMED ",
				"background: lime; color: black; padding: 5px 10px; font-weight: bold;",
			);
			document.dispatchEvent(new CustomEvent("RAVENTIC SEARCH RESULTS TRANSFORMED"));
		}

		document.addEventListener("RAVENTIC SEARCH RESULTS LOADED", () => {
			observer.disconnect();
			const list = document.querySelector(RV_LIST_SELECTOR);
			if (list) {
				findExistingTransformed(list)?.remove();
				delete list.dataset[TRANSFORMED_FLAG];
			}
			observer.observe(document.body, { childList: true, subtree: true });
		});

		transformResults();

		const observer = new MutationObserver(() => {
			if (
				document.querySelector(".raventic-search-results-filters-filter-price") &&
				!document.querySelector(".raventic-price-slider")
			) {
				scheduleRaventicPriceSlider();
			}
			const list = document.querySelector(RV_LIST_SELECTOR);
			if (!list) return;
			if (list.dataset[TRANSFORMED_FLAG] === "true") return;
			if (list.querySelector(".raventic-product")) transformResults();
		});
		observer.observe(document.body, { childList: true, subtree: true });
	}

	function addGoToTopButton() {
		const previousBtn = document.querySelector(".goToTop");
		if (previousBtn) {
			return;
		}

		const paginator = document.querySelector(".raventic-search-results-paginator");
		if (!paginator) return;

		const raventicHeading = document.querySelector(".raventic-search-results-container");
		if (!raventicHeading) {
			return;
		}
		raventicHeading.id = "productsListHeading";

		const goToTop = document.createElement("div");
		goToTop.className = "goToTop";
		goToTop.innerHTML =
			'<a class="goToTop__button btn btn-secondary" href="#productsListHeading" aria-label="' +
			window.NAT.translations("nahoru") +
			'" data-testid="buttonPageUp">' +
			window.NAT.translations("nahoru") +
			"</a>";
		paginator.prepend(goToTop);
		window.NAT.utils.goTopBtn();
	}

	// The v4 SDK renders every enum filter group with the same generic class, so the
	// only reliable way to target a specific group is by its <h3> title text. Kategorie
	// also has a dedicated class, but matching by title keeps all removals consistent.
	function removeUnwantedFilters() {
		const unwantedTitles = [
			"Kategorie",
			"Množství",
			"Denní dávka",
			"Kategórie",
			"Vstřebatelnost",
			"Objem",
			"Množstvo",
			"Denná dávka",
			"Vstrebateľnosť",
			"Ilość",
			"Dzienna dawka",
			"Pojemność",
		];

		const filters = document.querySelectorAll(".raventic-search-results-filters-filter");
		filters.forEach((filter) => {
			const title = filter.querySelector("h3 span")?.textContent.trim();
			if (title && unwantedTitles.includes(title)) filter.remove();
		});
	}

	let priceSliderTimer = null;

	function scheduleRaventicPriceSlider() {
		if (priceSliderTimer) clearTimeout(priceSliderTimer);
		priceSliderTimer = setTimeout(function () {
			priceSliderTimer = null;
			mountRaventicPriceSliders();
		}, 50);
	}

	function parsePrice(value) {
		if (value == null) return null;
		const normalized = String(value).trim().replace(/\s/g, "").replace(",", ".");
		if (!normalized) return null;
		const number = Number.parseFloat(normalized);
		return Number.isNaN(number) ? null : number;
	}

	function setInputValue(input, value) {
		const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value").set;
		setter.call(input, value);
	}

	function commitPriceInput(input) {
		input.dispatchEvent(new FocusEvent("focusout", { bubbles: true }));
	}

	function mountRaventicPriceSliders() {
		document.querySelectorAll(".raventic-search-results-filters-filter-price").forEach(function (filter) {
			const selector = filter.querySelector(".raventic-search-results-filters-filter-price-selector");
			if (!selector) return;
			const inputs = selector.querySelectorAll("input");
			if (inputs.length < 2) return;
			const minInput = inputs[0];
			const maxInput = inputs[1];
			const boundMin = parsePrice(minInput.getAttribute("placeholder"));
			const boundMax = parsePrice(maxInput.getAttribute("placeholder"));
			if (boundMin == null || boundMax == null || boundMax <= boundMin) return;

			let slider = filter.querySelector(".raventic-price-slider");
			if (!slider) {
				slider = document.createElement("div");
				slider.className = "raventic-price-slider";
				slider.innerHTML =
					'<div class="raventic-price-slider__track">' +
					'<div class="raventic-price-slider__range"></div>' +
					'<span class="raventic-price-slider__handle raventic-price-slider__handle--min" role="slider" tabindex="0"></span>' +
					'<span class="raventic-price-slider__handle raventic-price-slider__handle--max" role="slider" tabindex="0"></span>' +
					"</div>";
				selector.before(slider);
				bindPriceSlider(slider, minInput, maxInput);
			}

			const currentMin = parsePrice(minInput.value) ?? boundMin;
			const currentMax = parsePrice(maxInput.value) ?? boundMax;
			positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax);
		});
	}

	function positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax) {
		const span = boundMax - boundMin;
		const minRatio = span ? (currentMin - boundMin) / span : 0;
		const maxRatio = span ? (currentMax - boundMin) / span : 1;
		const minHandle = slider.querySelector(".raventic-price-slider__handle--min");
		const maxHandle = slider.querySelector(".raventic-price-slider__handle--max");
		const range = slider.querySelector(".raventic-price-slider__range");
		minHandle.style.left = minRatio * 100 + "%";
		maxHandle.style.left = maxRatio * 100 + "%";
		range.style.left = minRatio * 100 + "%";
		range.style.width = (maxRatio - minRatio) * 100 + "%";
		minHandle.setAttribute("aria-valuemin", String(boundMin));
		minHandle.setAttribute("aria-valuemax", String(boundMax));
		minHandle.setAttribute("aria-valuenow", String(currentMin));
		maxHandle.setAttribute("aria-valuemin", String(boundMin));
		maxHandle.setAttribute("aria-valuemax", String(boundMax));
		maxHandle.setAttribute("aria-valuenow", String(currentMax));
	}

	function bindPriceSlider(slider, minInput, maxInput) {
		const track = slider.querySelector(".raventic-price-slider__track");
		slider.querySelectorAll(".raventic-price-slider__handle").forEach(function (handle) {
			const side = handle.classList.contains("raventic-price-slider__handle--min") ? "min" : "max";
			handle.addEventListener("pointerdown", function (event) {
				if (event.button != null && event.button !== 0) return;
				event.preventDefault();
				const boundMin = parsePrice(minInput.getAttribute("placeholder"));
				const boundMax = parsePrice(maxInput.getAttribute("placeholder"));
				if (boundMin == null || boundMax == null) return;
				const input = side === "min" ? minInput : maxInput;
				const drag = {
					side: side,
					input: input,
					boundMin: boundMin,
					boundMax: boundMax,
					startRaw: input.value,
					pointerId: event.pointerId,
				};
				handle.setPointerCapture(event.pointerId);

				function valueFromEvent(pointerEvent) {
					const rect = track.getBoundingClientRect();
					const ratio = rect.width ? (pointerEvent.clientX - rect.left) / rect.width : 0;
					const clamped = Math.min(1, Math.max(0, ratio));
					let next = Math.round(boundMin + clamped * (boundMax - boundMin));
					const other = side === "min" ? parsePrice(maxInput.value) ?? boundMax : parsePrice(minInput.value) ?? boundMin;
					if (side === "min") next = Math.min(next, other);
					else next = Math.max(next, other);
					return next;
				}

				function onMove(pointerEvent) {
					if (pointerEvent.pointerId !== drag.pointerId) return;
					const next = valueFromEvent(pointerEvent);
					setInputValue(drag.input, String(next));
					const currentMin = side === "min" ? next : parsePrice(minInput.value) ?? boundMin;
					const currentMax = side === "max" ? next : parsePrice(maxInput.value) ?? boundMax;
					positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax);
				}

				function onUp(pointerEvent) {
					if (pointerEvent.pointerId !== drag.pointerId) return;
					handle.removeEventListener("pointermove", onMove);
					handle.removeEventListener("pointerup", onUp);
					handle.removeEventListener("pointercancel", onUp);
					const next = valueFromEvent(pointerEvent);
					const atBound = side === "min" ? next <= boundMin : next >= boundMax;
					const nextValue = atBound ? "" : String(next);
					if (nextValue === drag.startRaw) {
						setInputValue(drag.input, drag.startRaw);
						const currentMin = parsePrice(minInput.value) ?? boundMin;
						const currentMax = parsePrice(maxInput.value) ?? boundMax;
						positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax);
						return;
					}
					setInputValue(drag.input, nextValue);
					commitPriceInput(drag.input);
				}

				handle.addEventListener("pointermove", onMove);
				handle.addEventListener("pointerup", onUp);
				handle.addEventListener("pointercancel", onUp);
			});

			handle.addEventListener("keydown", function (event) {
				if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
				event.preventDefault();
				const boundMin = parsePrice(minInput.getAttribute("placeholder"));
				const boundMax = parsePrice(maxInput.getAttribute("placeholder"));
				if (boundMin == null || boundMax == null) return;
				const input = side === "min" ? minInput : maxInput;
				const previous = input.value;
				const step = event.shiftKey ? 10 : 1;
				const direction = event.key === "ArrowRight" ? 1 : -1;
				let next = Math.round((parsePrice(input.value) ?? (side === "min" ? boundMin : boundMax)) + step * direction);
				const other = side === "min" ? parsePrice(maxInput.value) ?? boundMax : parsePrice(minInput.value) ?? boundMin;
				if (side === "min") next = Math.max(boundMin, Math.min(next, other));
				else next = Math.min(boundMax, Math.max(next, other));
				const atBound = side === "min" ? next <= boundMin : next >= boundMax;
				const nextValue = atBound ? "" : String(next);
				if (nextValue === previous) return;
				setInputValue(input, nextValue);
				const currentMin = parsePrice(minInput.value) ?? boundMin;
				const currentMax = parsePrice(maxInput.value) ?? boundMax;
				positionPriceSlider(slider, boundMin, boundMax, currentMin, currentMax);
				commitPriceInput(input);
			});
		});
	}

	function addFilterHeading() {
		const raventicSelectedFiltersWrapper = document.querySelector(".raventic-search-results-filter-selection");
		if (!raventicSelectedFiltersWrapper) return;

		const existingHeading = raventicSelectedFiltersWrapper.querySelector(".selected-filters-heading");
		if (existingHeading) return;

		const selectedFiltersHeading = document.createElement("div");
		selectedFiltersHeading.className = "selected-filters-heading";
		selectedFiltersHeading.textContent = window.NAT.translations("selectedFilters");
		raventicSelectedFiltersWrapper.prepend(selectedFiltersHeading);
	}

	// The v4 SDK renders every promo block with the same generic class, so add a
	// per-identifier modifier (e.g. raventic-search-results-promo-content-type--categories)
	// to allow styling each block separately. The title->identifier map is read from the
	// widget config (window.RaventicSearchResultsConfig) so there's a single source of truth.
	function addPromoContentClasses() {
		const promoContent = window.RaventicSearchResultsConfig?.config?.promoContent;
		if (!Array.isArray(promoContent)) return;

		const titleToIdentifier = new Map(promoContent.map((item) => [item.title, item.identifier]));

		const blocks = document.querySelectorAll(".raventic-search-results-promo-content-type");
		blocks.forEach((block) => {
			const titleEl = block.querySelector(".raventic-search-results-promo-content-type-title");
			const identifier = titleEl ? titleToIdentifier.get(titleEl.textContent.trim()) : null;
			if (!identifier) return;
			block.classList.add(`raventic-search-results-promo-content-type--${identifier}`);
		});
		shortenBlogAdditionalContentInRaventicResults();
	}
}

function emptySearchQuery() {
	const headerSearch = document.querySelector("#header .search");
	if (!headerSearch) return;
	const queryInput = headerSearch.querySelector("input[type='search']");
	if (queryInput) {
		queryInput.value = "";
	}
}

function shortenBlogAdditionalContentInRaventicResults() {
	const MAX_LENGTH = 35;
	console.log("Shortening blog additional content in Raventic results...");

	const spans = document.querySelectorAll(".raventic-search-results-promo-content-type--articles span");
	console.log(`Found ${spans.length} spans to shorten.`);
	spans.forEach((span) => {
		const original = span.textContent.trim();

		// Already shortened on a previous run — leave it (and its title) untouched.
		if (original.endsWith("...")) return;

		span.title = original;

		if (original.length <= MAX_LENGTH) return;

		// Keep whole words up to and including the one that crosses MAX_LENGTH,
		// so the text never ends mid-word.
		const words = original.split(/\s+/);
		let shortened = "";
		for (const word of words) {
			shortened += (shortened ? " " : "") + word;
			if (shortened.length >= MAX_LENGTH) break;
		}
		span.textContent = shortened + "...";
	});
}

function addSearchButtonForMobile() {
	const body = document.body;

	const headerSearch = document.querySelector("#header .search");
	if (!headerSearch) return;

	const headerTop = document.querySelector("#header .header-top");
	if (!headerTop) return;

	const headerSearchFormRaventic = document.querySelector("#header .search-form");
	if (!headerSearchFormRaventic) return;

	const queryInput = headerSearch.querySelector("input[type='search']");
	if (!queryInput) return;

	headerSearchFormRaventic.addEventListener("click", function () {
		console.log("-------- CLICK");
		headerSearch.classList.toggle("custom-search-active");

		if (body.classList.contains("raventic-search-dropdown-open")) {
			body.classList.add("custom-search-active");
		}

		if (queryInput) {
			// timeout 10ms to wait for the animation to finish
			setTimeout(() => {
				if (
					document.body.classList.contains("raventic-search-dropdown-open") ||
					document.body.classList.contains("custom-search-active")
				) {
					queryInput.click();
					console.log("-------- Raventic Search Dropdown Opened (from mobile search button) ------");
				}
				queryInput.focus();
			}, 10);
		}

		const searchHeight = headerSearch.offsetHeight;
		document.body.style.setProperty("--mobile-search-height", searchHeight + "px");
		document.body.classList.remove("has-opened-hamburger-menu");
	});
}

// When the user clicks anywhere other than "#header .search" (and its children) or
// ".raventic-search-dropdown-body" (and its children), remove custom-search-active
// from body.
function clickOutsideSearchDropdown() {
	document.addEventListener("click", function (event) {
		if (!document.body.classList.contains("custom-search-active")) {
			return;
		}
		const headerSearch = document.querySelector("#header .search");
		const dropdownBody = document.querySelector(".raventic-search-dropdown-body");

		if (headerSearch && dropdownBody && !headerSearch.contains(event.target) && !dropdownBody.contains(event.target)) {
			document.body.classList.remove("custom-search-active");
			console.log("-------- Raventic Search Dropdown Closed (clicked outside) ------");
		}
	});
}
